import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { UiTranslateModule } from '@fcom/ui-translate';
import { ComponentsModule, DirectiveModule, PipesModule } from '@fcom/common';
import { BookingWidgetModule } from '@fcom/booking-widget/booking-widget.module';

import { BookingCommonModule } from '../common/booking-common.module';
import { BookingEntryRouteComponent } from './routes/booking-entry-route.component';

@NgModule({
  imports: [
    CommonModule,
    ComponentsModule,
    BookingCommonModule,
    PipesModule,
    DirectiveModule,
    UiTranslateModule,
    BookingWidgetModule,
  ],
  declarations: [BookingEntryRouteComponent],
  exports: [BookingEntryRouteComponent],
  providers: [],
})
export class EntryModule {}
